module.exports = __webpack_public_path__ + "img/speed_red.66d3cccb.svg";